import { NgModule } from '@angular/core';
import { MODALS } from '@freelancer/ui/modal';

@NgModule({
  providers: [
    {
      provide: MODALS,
      useValue: () =>
        import('./language-switcher-modal-routes').then(
          m => m.languageSwitcherModals,
        ),
      multi: true,
    },
  ],
})
export class LanguageSwitcherModalsModule {}
